import { SearchParam } from 'types/Search/params';

export const getSelected = (
    isDirectFlight: boolean,
    hasWithNoBag: boolean
): string[] => {
    const selected = [];
    if (isDirectFlight) {
        selected.push(SearchParam.DirectFlight);
    }
    if (hasWithNoBag) {
        selected.push(SearchParam.WithNoBag);
    }

    return selected;
};
